import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import OrderSuccess from "@/pages/OrderSuccess";
import NutritionGuide from "@/pages/NutritionGuide";
import AuthCallback from "@/pages/AuthCallback";
import MyOrders from "@/pages/MyOrders";
import Admin from "@/pages/Admin";
import Contact from "@/pages/Contact";
import Rider from "@/pages/Rider";
import OrderTracking from "@/pages/OrderTracking";
import ImageStudio from "@/pages/ImageStudio";
import Legal from "@/pages/Legal";
import { InstallPrompt } from "@/components/InstallPrompt";
import AiChat from "@/components/ai/AiChat";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/order/:orderId" element={<OrderSuccess />} />
      <Route path="/nutrition/sprouted-millet-protein-powder" element={<NutritionGuide />} />
      <Route path="/account/orders" element={<MyOrders />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/order/:orderId/tracking" element={<OrderTracking />} />
      <Route path="/rider" element={<Rider />} />
      <Route path="/image-studio" element={<ImageStudio />} />
      <Route path="/legal" element={<Legal />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <AppRouter />
          <AiChat />
        </BrowserRouter>
        <Toaster position="top-center" richColors />
        <InstallPrompt />
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
